import {invert, mapValues} from 'lodash';

// Domestic Ranks
export const COACH = 'COACH';
export const SENIOR_COACH = 'SENIOR_COACH';
export const MANAGER = 'MANAGER';
export const ASSOCIATE_DIRECTOR = 'ASSOCIATE_DIRECTOR';
export const DIRECTOR = 'DIRECTOR';
export const EXECUTIVE_DIRECTOR = 'EXECUTIVE_DIRECTOR';
export const INTEGRATED_EXECUTIVE_DIRECTOR = 'INTEGRATED_EXECUTIVE_DIRECTOR';
export const REGIONAL_DIRECTOR = 'REGIONAL_DIRECTOR';
export const INTEGRATED_REGIONAL_DIRECTOR = 'INTEGRATED_REGIONAL_DIRECTOR';
export const NATIONAL_DIRECTOR = 'NATIONAL_DIRECTOR';
export const INTEGRATED_NATIONAL_DIRECTOR = 'INTEGRATED_NATIONAL_DIRECTOR';
export const GLOBAL_DIRECTOR = 'GLOBAL_DIRECTOR';
export const INTEGRATED_GLOBAL_DIRECTOR = 'INTEGRATED_GLOBAL_DIRECTOR';
export const PRESIDENTIAL_DIRECTOR = 'PRESIDENTIAL_DIRECTOR';
export const INTEGRATED_PRESIDENTIAL_DIRECTOR =
  'INTEGRATED_PRESIDENTIAL_DIRECTOR';

// International Ranks
export const OPTAVIA_COACH = 'OPTAVIA_COACH';
export const INTERNATIONAL_SENIOR_COACH = 'INTERNATIONAL_SENIOR_COACH';
export const EXECUTIVE_COACH = 'EXECUTIVE_COACH';
export const MASTER_COACH = 'MASTER_COACH';
export const BUSINESS_LEADER = 'BUSINESS_LEADER';
export const SENIOR_BUSINESS_LEADER = 'SENIOR_BUSINESS_LEADER';
export const EXECUTIVE_BUSINESS_LEADER = 'EXECUTIVE_BUSINESS_LEADER';
export const MASTER_BUSINESS_LEADER = 'MASTER_BUSINESS_LEADER';
export const TRANSFORMATIONAL_BUSINESS_LEADER =
  'TRANSFORMATIONAL_BUSINESS_LEADER';

export const RANK_DISPLAY_NAME = {
  [COACH]: 'OPTAVIA Coach',
  [SENIOR_COACH]: 'Senior Coach',
  [MANAGER]: 'Manager',
  [ASSOCIATE_DIRECTOR]: 'Associate Director',
  [DIRECTOR]: 'Director',
  [EXECUTIVE_DIRECTOR]: 'Executive Director',
  [INTEGRATED_EXECUTIVE_DIRECTOR]: 'Integrated Executive Director',
  [REGIONAL_DIRECTOR]: 'Regional Director',
  [INTEGRATED_REGIONAL_DIRECTOR]: 'Integrated Regional Director',
  [NATIONAL_DIRECTOR]: 'National Director',
  [INTEGRATED_NATIONAL_DIRECTOR]: 'Integrated National Director',
  [GLOBAL_DIRECTOR]: 'Global Director',
  [INTEGRATED_GLOBAL_DIRECTOR]: 'Integrated Global Director',
  [PRESIDENTIAL_DIRECTOR]: 'Presidential Director',
  [INTEGRATED_PRESIDENTIAL_DIRECTOR]: 'Integrated Presidential Director',

  [OPTAVIA_COACH]: 'OPTAVIA Coach',
  [INTERNATIONAL_SENIOR_COACH]: 'Senior Coach',
  [EXECUTIVE_COACH]: 'Executive Coach',
  [MASTER_COACH]: 'Master Coach',
  [BUSINESS_LEADER]: 'Business Leader',
  [SENIOR_BUSINESS_LEADER]: 'Senior Business Leader',
  [EXECUTIVE_BUSINESS_LEADER]: 'Executive Business Leader',
  [MASTER_BUSINESS_LEADER]: 'Master Business Leader',
  [TRANSFORMATIONAL_BUSINESS_LEADER]: 'Transformational Business Leader',
};

export const RANK_BY_ID = {
  1: COACH,
  10: SENIOR_COACH,
  20: MANAGER,
  30: ASSOCIATE_DIRECTOR,
  40: DIRECTOR,
  50: EXECUTIVE_DIRECTOR,
  60: INTEGRATED_EXECUTIVE_DIRECTOR,
  70: REGIONAL_DIRECTOR,
  80: INTEGRATED_REGIONAL_DIRECTOR,
  90: NATIONAL_DIRECTOR,
  100: INTEGRATED_NATIONAL_DIRECTOR,
  110: GLOBAL_DIRECTOR,
  120: INTEGRATED_GLOBAL_DIRECTOR,
  130: PRESIDENTIAL_DIRECTOR,
  140: INTEGRATED_PRESIDENTIAL_DIRECTOR,

  201: OPTAVIA_COACH,
  205: INTERNATIONAL_SENIOR_COACH,
  210: EXECUTIVE_COACH,
  215: MASTER_COACH,
  220: BUSINESS_LEADER,
  225: SENIOR_BUSINESS_LEADER,
  230: EXECUTIVE_BUSINESS_LEADER,
  235: MASTER_BUSINESS_LEADER,
  240: TRANSFORMATIONAL_BUSINESS_LEADER,
};

export const ID_BY_RANK = mapValues(invert(RANK_BY_ID), parseInt);
